// Бронь на сайте: открыть окно брони из любого раздела (карточки «Мест», отели, поезда, билет, тур) и «Мои брони»
// (номера и ключи броней — только в этом браузере). Само окно — features/booking, монтируется при первом открытии.
import type { BookingPriceFor, BookingStatus } from '@sayohat/shared';
import { store as storage } from './storage';
import { createStore } from './store';

/** Что бронируют: снимок карточки (как позиция «Моего тура») и подсказки для формы */
export interface BookingRequest {
  /** activity, transfer, car, bus, train, flight, hotel, restaurant, attraction… */
  kind: string;
  /** источник карточки: sayohat — каталог турфирмы (только бронь на сайте) */
  source: string;
  /** id у источника (для sayohat — id позиции каталога) */
  id?: string | null;
  title: string;
  details?: string;
  /** вид по-русски для заголовка: «Экскурсия», «Трансфер» */
  kindLabel?: string;
  price: number | null;
  currency: string;
  priceFor?: BookingPriceFor;
  /** цена «от» (у партнёра) — итог оценочный */
  from?: boolean;
  /** страница у партнёра (вторая кнопка «Забронировать на сайте …») */
  url?: string | null;
  /** название партнёра для кнопки */
  partner?: string;
  image?: string | null;
  city?: string | null;
  /** место встречи / адрес */
  place?: string | null;
  lat?: number | null;
  lon?: number | null;
  /** YYYY-MM-DD */
  date?: string | null;
  endDate?: string | null;
  /** HH:MM */
  time?: string | null;
  /** даты — диапазон (отель: заезд — выезд; аренда авто) */
  range?: boolean;
  people?: { adults: number; children: number };
  /** не больше человек (каталог турфирмы) */
  maxPeople?: number | null;
  /** позиция «Моего тура», из которой бронируют: после брони она получит номер брони */
  tripItemId?: string | null;
}

export interface BookingUiState {
  req: BookingRequest | null;
  open: boolean;
  /** окно «Мои брони» */
  mine: boolean;
  n: number;
}

export const bookingUi = createStore<BookingUiState>({ req: null, open: false, mine: false, n: 0 });

export function openBooking(req: BookingRequest): void {
  bookingUi.set((s) => ({ req, open: true, mine: false, n: s.n + 1 }));
}

export const openMyBookings = (): void => bookingUi.set({ mine: true, open: false });

// ---------- «Мои брони» в браузере ----------

export interface SavedBooking {
  id: string;
  key: string;
  title: string;
  date: string | null;
  createdAt: string;
  /** последний известный статус */
  status?: BookingStatus;
}

const KEY = 'bookings';

export const savedBookings = (): SavedBooking[] => {
  const list = storage.get<SavedBooking[]>(KEY, []);
  return Array.isArray(list) ? list.filter((b) => b && typeof b.id === 'string' && typeof b.key === 'string') : [];
};

/** Запомнить (новые — первыми, не больше 50) */
export function rememberBooking(b: SavedBooking): void {
  storage.set(KEY, [b, ...savedBookings().filter((x) => x.id !== b.id)].slice(0, 50));
}

export function updateSavedStatus(id: string, status: BookingStatus): void {
  const list = savedBookings();
  const i = list.findIndex((x) => x.id === id);
  if (i === -1 || list[i].status === status) return;
  list[i] = { ...list[i], status };
  storage.set(KEY, list);
}

export function forgetBooking(id: string): void {
  storage.set(KEY, savedBookings().filter((x) => x.id !== id));
}
